import { QRFC } from "./QRFC";

export class QSignOffRFC extends QRFC {
  constructor() {
    super();
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
    this.fIsAsync = true;
  }

  SetParams(user, org, token) {
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("expireToken", token);
  }

  GetCallName() {
    return "qsignoff";
  }

  DoTransactionComplete(response, callBackObj) {
    //if (r == 'failure')
    //	success = false;
    //callBackObj.ExcelXMLResult(success, r);
  }

  DoSessionEnded(response, callBackObj) {}
}
